export default {
  'progress.prefix': 'Stap',
  'summary.target-date': 'Target date',
  'summary.other-situation-values.box-street': 'I want to have a <b>footpath cabinet in the street</b> moved or removed.',
  'summary.other-situation-values.box-facade': 'I want to have a <b>network cabinet in the street</b> moved or removed.',
  'summary.other-situation-values.connector-cable': 'I want to have a <b>connection point</b> on a facade or pylon moved or removed.',
  'summary.other-situation-values.pole': 'I want to have a <b>network cable</b> on a facade, a pylon, or to your house moved or removed.',
  'date.proceed': 'Continue with this date',
  'date.confirm': 'Confirm your chosen date.',
};
